import { getUniqueIdentifier } from '../../services/utils/validators/structures/adapter.utils';
import { HttpHeadersPayload } from '../utils';

export const commonHeaderInfo: HttpHeadersPayload = {
  'Content-Type': 'application/json',
  transactionId: getUniqueIdentifier()
};

export const COMMON_HEADER_KEY =
  'a7db5c62796b1c42819fd82996439459dae6fa91b5e95a7dcdf09544a7809bc5';

export const enum CommonConstants {
  EXIST = 'exist',
  NEW = 'new',
  TIMEOUT = 30000,
  MAX_TIMEOUT = 40000
}

export const enum TYPE {
  DELTA_360 = '360',
  MIN_LIMIT = '0',
  COMPLETE_LABEL = 'Complete',
  PENDING_EARNINGS = 'pending-earnings',
  QUALIFICATION_MILES = 'miles',
  QUALIFICATION_SEGMENTS = 'segments',
  QUALIFICATION_DOLLARS = 'dollars',
  QUALIFICATION_CARDS = 'cards',
  LOCALE = 'en-us',
  DIGITS_INFO = '1.0-0',
  OPTIONS_YEAR = 'numeric',
  OPTIONS_MONTH = 'short',
  OPTIONS_DEFAULT = 'default',
  NAME_PLACEHOLDER = '<NAME>',
  MONTH_PLACEHOLDER = '<Month>',
  YEAR_PLACEHOLDER = '<Year>',
  DATE_FORMAT = 'yyyy-MM-dd',
  X_PLACEHOLDER = '<X>',
  YEARS_LABEL = 'years',
  YEAR_LABEL = 'year',
  DEGREE = '°',
  REQUEST_TYPE = 'RETRIEVE_BYDOC_AND_COMBINE',
  APP = 'SKYMILES',
  CURRENCY_SYMBOL = '$',
  THOUSAND = 'k',
  TIME_ZONE = 'T12:00:00Z',
  MQD = 'MQDs',
  FUTURE = 'FUTURE',
  CURRENT = 'CURRENT',
  LIFETIME_MQM = 'LMQMs',
  AWARD_TRAVEL = 'award-travel',
  COMPLETE_PROFILE = 'complete-profile',
  EARNING_SIMPLER = 'earning-simpler',
  AVAIL = 'AVAIL',
  POSTED_ACTIVITY_COUNT = '${postedActivityCount}',
  MILLION_MILER = 'MM',
  DELTA_360_CODE = 'MV',
  TIER_CODE = 'MB',
  EDOCS_NO_DOCUMENT_CODE = 'PMT4170',
  NOT_APPLICABLE = 'N/A',
  DIAMOND_MEDALLION = 'DM',
  AIR_ACTIVITY_CODE = 'AA',
  ROLL = 'ROLL',
  ROLLOVER_MQM = 'Rollover MQMs',
  BEARER = 'Bearer',
  MEDALLION_STATUS = '[status]'
}

export type LevelType =
  | '0'
  | '1'
  | '2'
  | '3'
  | '4'
  | '5'
  | '6'
  | '7'
  | '8'
  | '9'
  | '10'
  | '11'
  | '12'
  | '13'
  | '14'
  | '15'
  | '16'
  | '17'
  | '18'
  | '19'
  | '20';
